import { actionType } from '../../constants/ApiResults';

export const clearApiResponsesAll = () => dispatch => {
  dispatch({
    type: actionType.CLEAR_API_ALL,
  });
};
